module.exports = __webpack_public_path__ + "img/dbg-ios.af5a5a72.png";